import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { Board } from "./Board";
import { AudioManager } from "../../AudioManager";
import { GameModel } from "../../GameModel";
import { GameState } from "../GameState";
import { FoundationPile } from "./FoundationPile";

export class Card extends Phaser.Sprite {
		
    public static BOUNDING_RECT: Phaser.Rectangle = new Phaser.Rectangle(-GameConstants.HALF_CARD_WIDTH, -GameConstants.HALF_CARD_HEIGHT,
                                GameConstants.CARD_WIDTH, GameConstants.CARD_HEIGHT);
    public static COLLISION_CIRCLE_RADIUS: number = 30;
    
    public static cardTweening: boolean = false;
            
    public cardValue: CardValue;
    public outerPileIndex: number;
    public foundationPileIndex: number;
    public boundingRectangle: Phaser.Rectangle;
    public pointsGiven: boolean;
    
    // coordinates of the collision circle
    public ccx: number;
    public ccy: number;
    
    private dragging: boolean;
    private aboveOuterPileIndex: number;
    private aboveFoundationPileIndex: number;
    private scaleTween: Phaser.Tween;
    private boundingCircle: Phaser.Image;
    private boundingRectangleSprite: Phaser.Sprite;
    private timeCardClicked: number;
    
    // dealing positions
    private dealing: boolean;
    private framesCounter: number;
    private framesStill: number;
    private index: number;
    private lastCardDealt: boolean;
    private dealPositions: Point[];
    private dealAudioTriggered: boolean;

    constructor(game: Phaser.Game , cardValue: CardValue) {

        var textureName: string = cardValue.value + "-" + cardValue.suit.toString() + ".png";
        
        super(game, 0, 0, "texture_atlas_2", textureName);
        
        this.cardValue = cardValue;
        
        this.pointsGiven = false;
        this.outerPileIndex = null;
        this.foundationPileIndex = null;
        this.dealAudioTriggered = false;
        
        // deal data
        this.dealing = false;
        this.framesCounter = 0;
        this.framesStill = 0;
        this.dealPositions = null;
        this.index = 0;
        this.lastCardDealt = false;
        this.dragging = false;
        
        this.anchor.setTo(.5, .5);
        
        this.boundingRectangle = Card.BOUNDING_RECT;
                                            
        // a rectangle for the collisions with the foundation piles
        this.boundingRectangleSprite = new Phaser.Sprite(this.game, - GameConstants.HALF_CARD_WIDTH, -GameConstants.HALF_CARD_HEIGHT, this.game.cache.getBitmapData("blue-square"));
        this.boundingRectangleSprite.scale.setTo(GameConstants.CARD_WIDTH / 16, GameConstants.CARD_HEIGHT / 16);
        this.boundingRectangleSprite.alpha = .3;
        this.addChild(this.boundingRectangleSprite);
            
        // a circle for the outer piles
        this.boundingCircle = new Phaser.Image(this.game, 0, 0 , "texture_atlas_1", "card-bounding-circle.png");
        this.boundingCircle.anchor.setTo(.5, .5);
        this.addChild(this.boundingCircle);
        
        if (!GameConstants.SHOW_BOUNDING_AREAS) {
            this.boundingRectangleSprite.visible = false;
            this.boundingCircle.alpha = 0;
        }

        this.events.onInputDown.add(this.onDown, this);
        this.events.onInputUp.add(this.onUp, this);	
        
    }
        
    public update(): void {
        
        if (this.dragging) {
            
            this.ccx = (this.boundingCircle.world.x - GameConstants.GAME_WIDTH / 2) / GameVars.scaleX;
            this.ccy = this.boundingCircle.world.y;
            
            // move the card, it isn't possible to use phaser dragging because the board is scaled        
            this.x = (this.game.input.activePointer.position.x - GameConstants.GAME_WIDTH / 2) / GameVars.scaleX;
            this.y = this.game.input.activePointer.position.y;
            
            var aboveFoundationPiles: boolean;
            
            if (this.anchor.y > .5) {
                aboveFoundationPiles = Board.currentInstance.boundingRectangleFoundationPiles.contains(this.x, this.y);
            } else {
                aboveFoundationPiles = Board.currentInstance.outerBoundingRectangleFoundationPiles.contains(this.x, this.y);
            }
            
            // check if the card center is inside the rectangle of the foundation pile
            if ( aboveFoundationPiles) {
                
                this.angle = 0;
                
                this.boundingRectangle.x = this.x - this.anchor.x * GameConstants.CARD_WIDTH;
                this.boundingRectangle.y = this.y - this.anchor.y * GameConstants.CARD_HEIGHT;
                
                this.aboveFoundationPileIndex = Board.currentInstance.checkCollisionsWithFoundationPiles(this);
                this.aboveOuterPileIndex = -1;
                
            } else {
    
                var dx: number = this.ccx;
                var dy: number = this.ccy - GameConstants.CENTER_OUTER_CARDS_Y;
                var a: number = Math.atan2(dy, dx);
                
                this.angle = 180 / Math.PI * a + 90;
                
                this.aboveFoundationPileIndex = -1;
                this.aboveOuterPileIndex = Board.currentInstance.checkCollisionsWithOuterPiles(this);
            }				
        }
        
        if (this.dealing) {
            
            if (this.framesCounter < this.framesStill) {
                
                this.framesCounter ++;
                
            } else {
                
                this.x = this.dealPositions[this.index].x;
                this.y = this.dealPositions[this.index].y;
                
                if (this.index < this.dealPositions.length - 1) {
                    this.index++;
                } else {
                    this.dealing = false;
                    
                    if (this.lastCardDealt) {
                        GameState.currentInstance.onCardsDealt();
                    }
                }
                
                if (this.index > 10 && !this.dealAudioTriggered) {
                    
                    this.dealAudioTriggered = true;
                    
                    var rnd: number = Math.random();
                    var sound: string;
                    
                    if (rnd < .4) {
                        sound = "cardfeed_1";
                    } else if (rnd < 7) {
                        sound = "cardfeed_2";
                    } else {
                        sound = "cardfeed_3";
                    }
                    
                    AudioManager.getInstance().playSound(sound);
                }
            }
        }
        
        super.update();
    }
    
    public dealToPile(dealData: DealData): void {
        
        this.dealing = true;
        this.framesStill = dealData.framesStill;
        this.dealPositions = dealData.positions;
        
        if (dealData.index === 103) {
            this.lastCardDealt = true;
        }
    }
        
    public enableDrag(): void {
        
        // contemplar el caso de que se cargue un juego con pilas completas
        if (this.foundationPileIndex !== null && this.foundationPileIndex > -1) {

            var foundationPile: FoundationPile = Board.currentInstance.foundationPiles[this.foundationPileIndex - 1];
            
            if (foundationPile.completed ||  this.cardValue.value === "A" || this.cardValue.value === "K" ) {
                return;
            }
        }
                
        this.inputEnabled = true;
        this.input.useHandCursor = true;
    }
    
    public disableDrag(): void {
        
        this.dragging = false;
        this.inputEnabled = false;
    }
    
    private onDown(): void {
        
        if (Card.cardTweening) {
            return;
        }
        
        this.timeCardClicked = this.game.time.now;

        // change the anchor point
        var px: number = (this.game.input.activePointer.position.x - GameConstants.GAME_WIDTH / 2) / GameVars.scaleX;
        var py: number = this.game.input.activePointer.position.y;
        
        // convert to the card's coordinate system            
        px -= this.x;
        py -= this.y;
        
        var a: number = - (this.angle + 180 ) * Math.PI / 180;
        
        var cx: number = - px * Math.cos(a) + py * Math.sin(a) + GameConstants.CARD_WIDTH / 2;
        var cy: number = - px * Math.sin(a) - py * Math.cos(a) + GameConstants.CARD_HEIGHT / 2;
        
        var ax: number = cx / GameConstants.CARD_WIDTH;
        var ay: number = cy / GameConstants.CARD_HEIGHT;

        this.anchor.setTo(ax, ay);
        
        this.boundingRectangleSprite.position.setTo(-cx, -cy);
        this.boundingCircle.position.setTo(-cx + GameConstants.CARD_WIDTH / 2 , -cy + GameConstants.CARD_HEIGHT / 2);
        
        this.scaleTween = this.game.add.tween(this.scale)
            .to({x: 1.1 , y: 1.1 }, 175 , Phaser.Easing.Cubic.Out, true);

        this.dragging = true;
        
        Board.currentInstance.onCardStartedDragging(this);
        
        // audio 
        AudioManager.getInstance().playSound("coger_carta");
    }
    
    private onUp(): void {
            
        this.dragging = false;
        
        if (this.scaleTween) {
            this.scaleTween.pendingDelete = true;
        }
        
        this.scale.setTo(1, 1);
        
        this.anchor.setTo(.5, .5);
        
        if (GameConstants.SHOW_BOUNDING_AREAS) {
            this.boundingRectangleSprite.position.setTo(-GameConstants.CARD_WIDTH / 2, -GameConstants.CARD_HEIGHT / 2);
            this.boundingCircle.position.setTo(0, 0);
        }
        
        // no se activa con las cartas que ya estan en las foundation piles
        if (this.game.time.now - this.timeCardClicked < 300 && this.outerPileIndex > -1) {
            GameModel.currentInstance.onCardQuicklyReleased(this);
        } else {
            
            // inform the model that a card has been released somewhere on the board 
            if (this.aboveFoundationPileIndex > 0) {
                
                GameModel.currentInstance.onCardReleasedAboveFoundationPile(this, this.aboveFoundationPileIndex );
                
            } else if (this.aboveOuterPileIndex > 0) {
                
                GameModel.currentInstance.onCardReleasedAboveOuterPile(this, this.aboveOuterPileIndex );
                
            } else {
                
                GameModel.currentInstance.onCardReleasedNowhere(this);
            }
        }
        
        // audio 
        AudioManager.getInstance().playSound("soltar_carta");
    }
}
